import request from "@/utils/request";
// 同步视频分类
export const syncCategory = (query) =>{
    return request({
        url: "/businessservice/humanityCategory/syncCategory",
        method:"get",
        params: query
    })
}

// 查询视频分类（树形结构）
export const treeCategory = (query) =>{
    return request({
        url: "/businessservice/humanityCategory/treeCategory",
        method:"get",
        params: query
    })
}

// 同步人文美育视频信息
export const  syncHumanityVideo =(query) =>{
    return request({
        url: "/businessservice/humanityVideo/syncHumanityVideo",
        method:"get",
        params: query
    })
}


// 分页查询人文美育视频信息
export const  pageHumanityVideo =(data) =>{
    return request({
        url: "/businessservice/humanityVideo/page",
        method:"post",
        data: data
    })
}

// 查询人文美育视频列表
export const  listHumanityVideo =(data) =>{
    return request({
        url: "/businessservice/humanityVideo/list",
        method:"post",
        data: data
    })
}

// 更新视频信息
export const  updateHumanityVideo =(data) =>{
    return request({
        url: "/businessservice/humanityVideo/update",
        method:"post",
        data: data
    })
}


// 同步人文美育视频信息
export const  searchHumanityVideo =(query) =>{
    return request({
        url: "/businessservice/humanityVideo/searchList",
        method:"get",
        params: query
    })
}

// 视频信息
export const  infoHumanityVideo =(query) =>{
    return request({
        url: "/businessservice/humanityVideo/info",
        method:"get",
        params: query
    })
}


